var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTime(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 2.66732C5.05416 2.66732 2.66634 5.05513 2.66634 8.00065C2.66634 10.9462 5.05416 13.334 7.99967 13.334C10.9452 13.334 13.333 10.9462 13.333 8.00065C13.333 5.05513 10.9452 2.66732 7.99967 2.66732ZM1.33301 8.00065C1.33301 4.31875 4.31778 1.33398 7.99967 1.33398C11.6816 1.33398 14.6663 4.31875 14.6663 8.00065C14.6663 11.6825 11.6816 14.6673 7.99967 14.6673C4.31778 14.6673 1.33301 11.6825 1.33301 8.00065Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4951 8.10522C11.4951 8.47341 11.1966 8.77189 10.8284 8.77189L7.72386 8.77189C7.35567 8.77189 7.05719 8.47341 7.05719 8.10522L7.05719 5.55294C7.05719 5.18475 7.35567 4.88627 7.72386 4.88627C8.09205 4.88627 8.39052 5.18475 8.39052 5.55294L8.39052 7.43855L10.8284 7.43855C11.1966 7.43855 11.4951 7.73703 11.4951 8.10522Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTime);
export default __webpack_public_path__ + "static/media/new-time.2ff16c174dc0a8e8e859cc4e2bd264e3.svg";
export { ForwardRef as ReactComponent };